import { CatalogResourceDc, CatalogResourceType } from "@evergis/api";
import { useBaseMap } from "../../../../../hooks/project/useBaseMap";
import { useBasemapAddDialog, useSelectFilesDialog } from "../../../../../hooks/useDialogs";
import { useResetFeatureCard } from "../../../../FeatureCard/hooks/useResetFeatureCard";
import { BaseMapTheme } from "../BasemapBlock";

export function useAddBasemapHandlers() {
  const openSelectFiles = useSelectFilesDialog();
  const { addMap } = useBaseMap();

  const fromLayersCatalog = useResetFeatureCard(
    () =>
      openSelectFiles([""], {
        onApply: (selectedResources: CatalogResourceDc[]) => {
          selectedResources.forEach(resource => {
            addMap({
              name: resource.systemName,
              title: resource.name,
              preview: "",
              theme: BaseMapTheme.Light,
            });
          });
        },
        filters: {
          resourceTypes: [CatalogResourceType.Layer],
          subtypes: ["RemoteTileService"],
        },
        hasActions: false,
      }),
    [openSelectFiles],
  );

  const showBasemapAddDialog = useBasemapAddDialog();
  const fillWithColor = useResetFeatureCard(() => showBasemapAddDialog(), [showBasemapAddDialog]);

  return {
    fromLayersCatalog,
    fillWithColor,
  };
}
